export enum MspCodesEnum {
  NON_EXIST = 'NON_EXIST',
  MICRO = 'MICRO',
  SMALL = 'SMALL',
  NORMAL = 'NORMAL',
}
